<template>
  <modal
    ref="modal"
    name="selectModal"
    :click-to-close="false"
    :width="729"
    :height="346"
    class="select-modal"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <select-content
      v-bind="callbacks"
      :is-upload="isUpload"
      :click-only="clickOnly"
      :upload-btn-tip="uploadBtnTip"
    ></select-content>
  </modal>
</template>

<script>
// this.$modal.show('selectModal', {
//   uploadBtnTip: '',
//   isUpload: false,
//   clickOnly: true,
//   onClickUpload: () => {},
//   onFile: (file) => {}, // 读取到本地文件时回调
//   onUrl: (url) => {}, // 文件传送到云端时回调
//   onInfo: (info) => {} // 点击我的作品打卡列表弹窗，选一个作品然后点击确定时回调
// });
import SelectContent from './selectContent';
import modalMixin from './modalMixin.js';
export default {
  components: {
    SelectContent
  },
  mixins: [modalMixin],
  data() {
    return {
      isUpload: true,
      clickOnly: false,
      uploadBtnTip: void 0
    };
  },
  methods: {
    beforeOpen(ev) {
      modalMixin.methods.beforeOpen.call(this, ev);
      if (ev.params.isUpload === false) {
        this.isUpload = false;
      } else {
        this.isUpload = true;
      }
      this.clickOnly = ev.params.clickOnly;
      let uploadBtnTip = ev.params.uploadBtnTip;
      if (uploadBtnTip && typeof uploadBtnTip === 'string') {
        this.uploadBtnTip = uploadBtnTip;
      } else {
        this.uploadBtnTip = void 0;
      }
    },
    closed() {
      this.$modal.hide('worksModal');
      this.$modal.hide('videoStoreModal');
      this.callbacks = '';
    }
  }
};
</script>

<style lang="scss" scoped></style>
